var map = {
	"./axia/icons/ppt.svg": 335,
	"./boomea/boomea/icons/ppt.svg": 345,
	"./boomea/icons/ppt.svg": 364,
	"./simplifi/icons/ppt.svg": 377
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 874;
module.exports = webpackAsyncContext;